export default class ovatBillChangeUkeyModalCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger, Upload, $timeout, $rootScope, $uibModal) {
        $scope.billInfo = {}
        $scope.items = items1
        const qryBillInfo = function (billId) {
            httpRequest.get_qryBillInfo(billId).then((res) => {
                $scope.billInfo = res.data.value
            })
        }
        qryBillInfo($scope.items)


        // 带搜索功能的下拉选择框相关方法
        function toSelect2data(list, idfield, textfield) {
            const result = []
            for (const a in list) {
                const tempdata = { id: '', text: '' }
                $.extend(tempdata, list[a])
                tempdata.id = list[a][idfield]
                tempdata.text = list[a][textfield]
                result.push(tempdata)
            }
            return result
        }
        $scope.config2 = { allowClear: false }
        $scope.aS2 = {}
        $scope.aS2.ukeyId = ''
        // httpRequest.post_getAssignUkeyList().then(res=>{
        //     $scope.config2.data = toSelect2data(res.data.value, "ukeyId", "ukeyName");
        // })
        $scope.config2.data = toSelect2data($scope.userInfo.sysUkeyList, 'ukeyId', 'ukeyName')


        $scope.ok = function () {
            const a = $scope.billInfo.ukeyId
            try {
                if ($scope.aS2.ukeyId == undefined || $scope.aS2.ukeyId == '') {
                    $scope.billInfo.ukeyId = a
                } else {
                    $scope.billInfo.ukeyId = $scope.aS2.ukeyId
                }
            } catch (error) {
                $scope.billInfo.ukeyId = a
            }
            console.log($scope.billInfo.ukeyId)
            httpRequest.post_modBill($scope.billInfo).then((res) => {
                logger.logSuccess('开票点信息修改成功')
                $uibModalInstance.close()
            })
        }

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/ovatBill/ovatBillChangeUkeyModalCtrl.js